import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeIcons } from 'primeng/api';
import { DataService } from '../services/data.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.css']
})
export class TrackerComponent {
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';

  //this is the overarching sample list.  in it there are individual timelines including original run and any retests
  listOfTimelines: any[];
  loading: boolean = true;
  searched: boolean = false;
  barcode: string;
  
  showMachines: boolean = true;
  showPred: boolean = true;
  showAdditionalInfo: boolean = true;
  useRetests: boolean = true;
  machinePercentages:any[] = [];

  flattenedJson: any = {};

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {

    /*this.trackers = [
        {status: 'Received', predictedDate: '20/10/2020 10:30', actualDate: '15/10/2020 10:30', icon: PrimeIcons.CHECK, color: '#22C55E', image: 'game-controller.jpg'},
        {status: 'Imaged', predictedDate: '20/10/2020 10:30', actualDate: '15/10/2020 14:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Lysed', predictedDate: '20/10/2020 10:30', actualDate: '15/10/2020 16:15', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Oven Start', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Oven End', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Neutralized', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Accessioned', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Iso Start', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Iso End', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#22C55E'},
        {status: 'Stamper', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#F59E0B'},
        {status: 'ABI Build Start', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.MINUS, color: '#F59E0B'},
        {status: 'ABI Build End', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.MINUS, color: '#EF4444'},
        {status: 'ABI Read Start', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.MINUS, color: '#607D8B'},
        {status: 'ABI Read End', predictedDate: '20/10/2020 10:30', actualDate: '16/10/2020 10:00', icon: PrimeIcons.MINUS, color: '#607D8B'}
    ];*/
  }

  getTrackerInfo(){
    this.searched = true;
    this.loading = true;
    this.machinePercentages = [];
    this.listOfTimelines = [];
    var barcodes = this.barcode.split(/,| /);
    var thisClass = this;
    var barcodeAmount = 0;
    barcodes.forEach(function (barcode) {
      if (barcode != "")
      {
        barcodeAmount++;
        thisClass.dataService.getEventsByBarcode(barcode).then(data => {
          thisClass.listOfTimelines.push(data);
          barcodeAmount--;
          if (barcodeAmount == 0)
          {
            thisClass.loading = false;
          }
        });
      }
    });
  }

  calculateSimilarity(){
    this.machinePercentages = [];
    this.listOfTimelines.forEach((timelines:any) =>{
      if (timelines != undefined && timelines[0] != undefined)
      {
        this.machinePercentages = [];
        timelines[0].events.forEach((event:any) => {
          this.machinePercentages.push({
            name: event.status,
            machines: this.getPercentageList(event.status)
          });
        });
      }
    });
  }

  getPercentageList(eventStatus: string)
  {
    var machineList:[] = [];
    var totalCount = 0;
    var useRetests = this.useRetests;
    this.listOfTimelines.forEach((timelines: any) => {
      if (timelines != undefined && timelines.length > 0)
      {
        if (!useRetests)
        {
          var event: any;
          //only source
          event = timelines[0].events.find((ev: any) => ev.status === eventStatus );
          if (event != undefined && event.machineName != null && event.machineName != "")
          {
            this.addOrIncrement(machineList, event.machineName);
            totalCount++;
          }
        }
        else
        {
          var event: any;
          timelines.forEach((timeline:any) => {
            event = timeline.events.find((ev: any) => ev.status === eventStatus );
            if (event != undefined && event.machineName != null && event.machineName != "")
            {
              this.addOrIncrement(machineList, event.machineName);
              totalCount++;
            }
          });
        }
      }
    });

    console.log(machineList);
    var machinePercentList: any[] = [];
    machineList.forEach((machine: any) => {
      machinePercentList.push({
        name: machine.value,
        percent: Math.round(machine.count / totalCount * 100)
      });
    });
    
    //return sorted list highest to lowest
    return machinePercentList.sort((a,b) => b.percent - a.percent);
  }

  addOrIncrement(arr: any, value: any) {
    const existingItem = arr.find((item: any) => item.value === value);
  
    if (existingItem) {
      existingItem.count++;
    } else {
      arr.push({ value, count: 1 });
    }
  }

  exportToExcel(){
    this.exportAsExcelFile(this.listOfTimelines, "TrackerData");
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.flattenJson(json));
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + this.EXCEL_EXTENSION);
  }

  flattenJson(listOfTimelines: any){
    var flattenedTimeline: any[] = [];
    listOfTimelines.forEach((timelines: any) => {
      timelines.forEach((timeline: any) => {
        var aPlates = timeline.detail.aPlate.split(',');
        aPlates.forEach((aPlate:any) => {
          flattenedTimeline.push({
            sPlate: timeline.detail.sPlate,
            lysed: timeline.events.find((ev: any) => ev.status === "Lysed" )?.machineName,
            neutralized: timeline.events.find((ev: any) => ev.status === "Neutralized" )?.machineName,
            aliquot: timeline.events.find((ev: any) => ev.status === "Aliquot" )?.machineName,
            plvPlate: timeline.detail.plvPlate,
            strainName: timeline.detail.strainName,
            accessioned: timeline.events.find((ev: any) => ev.status === "Accessioned" )?.machineName,
            retest: timeline.detail.retestType,
            worklist: timeline.detail.worklistName,
            dPlate: timeline.detail.dPlate,
            iso: timeline.events.find((ev: any) => ev.status === "Iso Start" )?.machineName,
            line: timeline.detail.processingLine,
            mmPlate: timeline.detail.mmPlate,
            abiBuild: timeline.events.find((ev: any) => ev.status === "ABI Build Start" )?.machineName,
            aPlate: aPlate,
            abiRead: timeline.events.find((ev: any) => ev.status === "ABI Read Start" )?.machineName
          });
        });
      });
    });
    return flattenedTimeline;
  }

  //T2031730,T2004218,T1987989,T2030249,T1999606,T1943590,T1899099
  //Т1978010,T1938399,T2019732,T1755168,T2006411,T2040229,T2030161,Т2031788,T1837344,T2012958,T1912919

}
